export default "__VITE_ASSET__deb21dd5__"